<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
      }
    },
    methods: {
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
        );
        return flag;
      },
    },
    mounted() {
      if (this._isMobile()) {
        // 手机端
        this.$router.replace("/mobileHome");
      } else {
        // pc端
        this.$router.replace("/home");
      }
    },
  }


</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue